import React from 'react';

import {
    MarkdownContent,
    PageSection,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './IntroSection.scss';

function IntroQuestions({ question, answer }) {
    return (
        <div className={styles.introQuestions}>
            <span className={styles.question}>
                {question}
            </span>
            <span className={styles.answer}>
                {answer}
            </span>
        </div>
    );
}

function IntroSection(props) {
    const {
        t,
    } = props;

    return (
        <PageSection
            className={styles.introSection}
            layoutClassName={styles.introSectionLayout}
        >
            <IntroQuestions
                answer={t('about-us-intro-subheader1')}
                question={t('about-us-intro-header1')}
            />
            <IntroQuestions
                answer={t('about-us-intro-subheader2')}
                question={t('about-us-intro-header2')}
            />
            <MarkdownContent className={styles.introText}>
                {t('about-us-intro-description')}
            </MarkdownContent>
        </PageSection>
    );
}

export {
    IntroQuestions,
    IntroSection,
};
export default localize(IntroSection, ['t'], 'baseApp');
